import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const BANCONTACT_QR_CODE: PaymentMethod = {
    id: PAYMENT_METHOD_ID.BancontactQRCode,
    name: 'bancontact',
    displayName: 'BancontactQR'
};
